
export function isDateOnly(value: string): boolean {
  return /^\d{4}-\d{2}-\d{2}$/.test(value);
}

export function parseScheduleDate(value?: string | null): Date {
  if (!value) return new Date(NaN);

  if (isDateOnly(value)) {
    const [year, month, day] = value.split('-').map(Number);
    return new Date(year, month - 1, day);
  }

  const match = value.match(
    /^(\d{4})-(\d{2})-(\d{2})[T\s](\d{2}):(\d{2})(?::(\d{2}))?/
  );

  if (match) {
    const [, y, m, d, hh, mm, ss = '0'] = match;
    return new Date(+y, +m - 1, +d, +hh, +mm, +ss);
  }

  return new Date(value);
}

export function toScheduleTimestamp(value?: string | null): number {
  const date = parseScheduleDate(value);

  if (Number.isNaN(date.getTime())) return 0;

  return date.getTime();
}